import { render, staticRenderFns } from "./WebResourceManage.vue?vue&type=template&id=225ec3ae&"
import script from "./WebResourceManage.vue?vue&type=script&lang=js&"
export * from "./WebResourceManage.vue?vue&type=script&lang=js&"
import style0 from "./WebResourceManage.vue?vue&type=style&index=0&id=225ec3ae&lang=scss&"
import style1 from "./WebResourceManage.vue?vue&type=style&index=1&id=225ec3ae&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225ec3ae')) {
      api.createRecord('225ec3ae', component.options)
    } else {
      api.reload('225ec3ae', component.options)
    }
    module.hot.accept("./WebResourceManage.vue?vue&type=template&id=225ec3ae&", function () {
      api.rerender('225ec3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/web-resource-manage/WebResourceManage.vue"
export default component.exports